import { CoreConversationFieldsFragment } from '@pm/graphql';
import clsx from 'clsx';
import { useMessageName } from '../../hooks/useMessageName';
import { DateTime } from '../DateTime';
import { TableCell } from '../Table/TableCell';

type MessageListRowProps = {
  conversation: CoreConversationFieldsFragment;
  brand: string;
};

export const MessageListRow = ({
  conversation,
  brand,
}: MessageListRowProps) => {
  const message = conversation.lastMessage;
  let otherUser = message.sender;

  if (message.recipient.role.code !== 'PATIENT') {
    otherUser = message.recipient;
  }

  const otherUserDisplayName = useMessageName(brand, otherUser);

  const path = `/conversations/${conversation.id}`;

  return (
    <tr
      className={clsx(
        'hover:bg-grey-50',
        !conversation.readByCurrentUser && 'font-bold',
      )}
    >
      {message.sender.role.code === 'PATIENT' ? (
        <TableCell to={path} className="sensitive">
          {message.sender.preferredName ||
            `${message.sender.firstName} ${message.sender.lastName}`}
        </TableCell>
      ) : (
        <TableCell to={path} className="sensitive">
          {otherUserDisplayName}
        </TableCell>
      )}
      <TableCell to={path} className="sensitive">
        {conversation.subject}
      </TableCell>
      <TableCell to={path}>
        <DateTime value={conversation.lastMessageSentAt} format="Pp" />
      </TableCell>
    </tr>
  );
};
